const ParentSocietyListIconSubcategory = () => {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_2692_10625)" />
      <g clip-path="url(#clip0_2692_10625)">
        <path
          d="M47.0707 25.7164H37.258C36.4084 25.7164 35.5935 25.3786 34.9924 24.7774L32.6671 22.4521C32.374 22.159 31.9815 22 31.5691 22H22.9289C21.3887 22 20.1416 23.2471 20.1416 24.7873V29.4328H49.858V28.5037C49.858 26.9635 48.6109 25.7164 47.0707 25.7164ZM20.1416 45.2177C20.1416 46.7579 21.3887 48.005 22.9289 48.005H47.0707C48.6109 48.005 49.858 46.7579 49.858 45.2177V31.2861H20.1416V45.2177Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2692_10625"
          x1="35"
          y1="0"
          x2="35"
          y2="70"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFB300" />
          <stop offset="1" stop-color="#EA8D03" />
        </linearGradient>
        <clipPath id="clip0_2692_10625">
          <rect width="29.7164" height="26" fill="white" transform="translate(20.1416 22)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ParentSocietyListIconSubcategory
